var _g, _g2, _g3, _g4, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 33,
    viewBox: "0 0 103 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_26_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.457965 21.9736C0.26549 21.7826 0.26044 21.4729 0.446582 21.2756L3.51976 18.0191C3.71043 17.817 4.02923 17.8092 4.22964 18.0015L11 24.5L11 32.439L0.457965 21.9736Z",
    fill: "#00615E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_26_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 24.4998L20.9416 14.7598C21.1234 14.5818 21.41 14.5686 21.6073 14.7293L25.1241 17.5931C25.3542 17.7805 25.3715 18.1258 25.1611 18.3352L10.9929 32.4379L10.9998 24.4998Z",
    fill: "#00615E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_26_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.72295 11.6389C2.52409 11.4511 2.51437 11.1398 2.69939 10.9383L5.99713 7.34839C6.19534 7.13261 6.53578 7.13274 6.73383 7.34867L11 12C11 12 10.9976 19.5463 11 19.5C11.0021 19.4593 4.35258 13.1777 2.72295 11.6389Z",
    fill: "#8FD2CD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_26_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 12L22.5155 0.359554C22.7113 0.16163 23.0311 0.161758 23.2267 0.359838L26.5146 3.68867C26.7107 3.88724 26.7104 4.20399 26.509 4.39717C24.1445 6.6649 11.0061 19.2755 11 19.5C10.9932 19.7467 11.0001 12 11.0001 12Z",
    fill: "#8FD2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 12L22.5155 0.359554C22.7113 0.16163 23.0311 0.161758 23.2267 0.359838L26.5146 3.68867C26.7107 3.88724 26.7104 4.20399 26.509 4.39717C24.1445 6.6649 11.0061 19.2755 11 19.5C10.9932 19.7467 11.0001 12 11.0001 12Z",
    fill: "#8FD2CD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.88 23.9793C36.648 23.9793 35.576 23.7313 34.664 23.2353C33.752 22.7233 33.048 22.0033 32.552 21.0753C32.056 20.1473 31.808 19.0593 31.808 17.8113C31.808 16.5633 32.056 15.4913 32.552 14.5953C33.048 13.6833 33.752 12.9873 34.664 12.5073C35.576 12.0113 36.648 11.7633 37.88 11.7633C38.632 11.7633 39.376 11.8833 40.112 12.1233C40.848 12.3633 41.456 12.6993 41.936 13.1313L41.048 15.2193C40.632 14.8513 40.16 14.5713 39.632 14.3793C39.12 14.1873 38.624 14.0913 38.144 14.0913C37.104 14.0913 36.296 14.4193 35.72 15.0753C35.16 15.7153 34.88 16.6353 34.88 17.8353C34.88 19.0193 35.16 19.9553 35.72 20.6433C36.296 21.3153 37.104 21.6513 38.144 21.6513C38.608 21.6513 39.104 21.5553 39.632 21.3633C40.16 21.1713 40.632 20.8833 41.048 20.4993L41.936 22.6113C41.456 23.0273 40.84 23.3633 40.088 23.6193C39.352 23.8593 38.616 23.9793 37.88 23.9793ZM43.7763 23.7393V6.81926H46.7763V14.3553H46.4403C46.7923 13.5073 47.3363 12.8673 48.0723 12.4353C48.8243 11.9873 49.6723 11.7633 50.6163 11.7633C51.5603 11.7633 52.3363 11.9393 52.9443 12.2913C53.5523 12.6433 54.0083 13.1793 54.3123 13.8993C54.6163 14.6033 54.7683 15.4993 54.7683 16.5873V23.7393H51.7683V16.7313C51.7683 16.1233 51.6883 15.6273 51.5283 15.2433C51.3843 14.8593 51.1523 14.5793 50.8323 14.4033C50.5283 14.2113 50.1363 14.1153 49.6563 14.1153C49.0803 14.1153 48.5763 14.2433 48.1443 14.4993C47.7123 14.7393 47.3763 15.0913 47.1363 15.5553C46.8963 16.0033 46.7763 16.5313 46.7763 17.1393V23.7393H43.7763ZM63.5994 23.9793C62.2714 23.9793 61.1274 23.7313 60.1674 23.2353C59.2074 22.7393 58.4634 22.0353 57.9354 21.1233C57.4234 20.2113 57.1674 19.1313 57.1674 17.8833C57.1674 16.6673 57.4154 15.6033 57.9114 14.6913C58.4234 13.7793 59.1194 13.0673 59.9994 12.5553C60.8954 12.0273 61.9114 11.7633 63.0474 11.7633C64.1674 11.7633 65.1274 12.0033 65.9274 12.4833C66.7274 12.9633 67.3434 13.6433 67.7754 14.5233C68.2234 15.4033 68.4474 16.4513 68.4474 17.6673V18.5553H59.5914V16.8273H66.3354L65.9514 17.1873C65.9514 16.0993 65.7114 15.2673 65.2314 14.6913C64.7514 14.0993 64.0634 13.8033 63.1674 13.8033C62.4954 13.8033 61.9194 13.9633 61.4394 14.2833C60.9754 14.5873 60.6154 15.0273 60.3594 15.6033C60.1194 16.1633 59.9994 16.8353 59.9994 17.6193V17.7873C59.9994 18.6673 60.1354 19.3953 60.4074 19.9713C60.6794 20.5473 61.0874 20.9793 61.6314 21.2673C62.1754 21.5553 62.8474 21.6993 63.6474 21.6993C64.3034 21.6993 64.9594 21.6033 65.6154 21.4113C66.2714 21.2033 66.8714 20.8833 67.4154 20.4513L68.2554 22.4673C67.6954 22.9313 66.9914 23.2993 66.1434 23.5713C65.2954 23.8433 64.4474 23.9793 63.5994 23.9793ZM76.2472 23.9793C75.0152 23.9793 73.9432 23.7313 73.0312 23.2353C72.1192 22.7233 71.4152 22.0033 70.9192 21.0753C70.4232 20.1473 70.1752 19.0593 70.1752 17.8113C70.1752 16.5633 70.4232 15.4913 70.9192 14.5953C71.4152 13.6833 72.1192 12.9873 73.0312 12.5073C73.9432 12.0113 75.0152 11.7633 76.2472 11.7633C76.9992 11.7633 77.7432 11.8833 78.4792 12.1233C79.2152 12.3633 79.8232 12.6993 80.3032 13.1313L79.4152 15.2193C78.9992 14.8513 78.5272 14.5713 77.9992 14.3793C77.4872 14.1873 76.9912 14.0913 76.5112 14.0913C75.4712 14.0913 74.6632 14.4193 74.0872 15.0753C73.5272 15.7153 73.2472 16.6353 73.2472 17.8353C73.2472 19.0193 73.5272 19.9553 74.0872 20.6433C74.6632 21.3153 75.4712 21.6513 76.5112 21.6513C76.9752 21.6513 77.4712 21.5553 77.9992 21.3633C78.5272 21.1713 78.9992 20.8833 79.4152 20.4993L80.3032 22.6113C79.8232 23.0273 79.2072 23.3633 78.4552 23.6193C77.7192 23.8593 76.9832 23.9793 76.2472 23.9793ZM82.1435 23.7393V6.81926H85.1435V16.9953H85.1915L89.9195 12.0033H93.5435L87.6395 18.2433V16.9953L93.8795 23.7393H90.2075L85.1915 18.5073H85.1435V23.7393H82.1435Z",
    fill: "#00615E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.94 14.7393V13.9113L98.808 10.8273C99.072 10.5393 99.284 10.2713 99.444 10.0233C99.612 9.76726 99.736 9.51926 99.816 9.27926C99.896 9.03926 99.936 8.79926 99.936 8.55926C99.936 8.09526 99.792 7.74326 99.504 7.50326C99.224 7.25526 98.812 7.13126 98.268 7.13126C97.852 7.13126 97.456 7.21126 97.08 7.37126C96.712 7.52326 96.364 7.75926 96.036 8.07926L95.628 7.22726C95.948 6.90726 96.352 6.65126 96.84 6.45926C97.328 6.26726 97.84 6.17126 98.376 6.17126C98.952 6.17126 99.436 6.26326 99.828 6.44726C100.228 6.62326 100.532 6.88326 100.74 7.22726C100.948 7.56326 101.052 7.97526 101.052 8.46326C101.052 8.71926 101.02 8.97126 100.956 9.21926C100.892 9.45926 100.796 9.70326 100.668 9.95126C100.548 10.1913 100.392 10.4393 100.2 10.6953C100.016 10.9513 99.796 11.2153 99.54 11.4873L97.056 14.1153V13.7913H101.388V14.7393H95.94Z",
    fill: "#00615E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_26_1526",
    x: 0.310059,
    y: 17.8622,
    width: 10.6899,
    height: 14.6768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26_1526"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_26_1526",
    x: 10.9932,
    y: 14.6171,
    width: 14.3154,
    height: 17.9208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26_1526"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_26_1526",
    x: 2.56689,
    y: 7.18665,
    width: 8.43311,
    height: 12.4135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26_1526"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_26_1526",
    x: 10.9971,
    y: 0.211182,
    width: 15.6636,
    height: 19.3946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0 0.223077 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26_1526"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.992a6dbb06ad31d8e5465e1be93e2cdc.svg";
export { ForwardRef as ReactComponent };